import { ValuableNode } from '../../models/ValuableNode'

export class SchemaDateTimeNode extends ValuableNode {}

declare global {
  export interface RehajeTypedNodes {
    'Schema.DateTime': SchemaDateTimeNode
  }
}
